export default {
  1: [
    {
      name:
        "babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",
      price: "299.00 ",
      url:
        "https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",
      description:
        "Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",
      category: ["Furniture"]
    },
    {
      name: "Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",
      price: "26.20 ",
      url:
        "https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",
      description:
        "From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",
      category: ["Nursery Décor"]
    },
    {
      name:
        "Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",
      price: "24.99 ",
      url:
        "https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",
      description:
        "As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",
      category: ["Bedding", "Apparel"]
    },
    {
      name:
        "Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",
      price: "17.99 ",
      url:
        "https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",
      description: "Nice design, and comfortable.",
      category: ["Bedding"]
    }
  ],
  2: [
    {
      name: "Summer Infant Contoured Changing Pad",
      price: "17.99 ",
      url:
        "https://www.amazon.com/gp/product/B009EDSWJA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B009EDSWJA&linkCode=as2&tag=shopmymom-20&linkId=54aba31d563825b601e78d2be55d1760",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/81%2Bev0VHJHL._SX522_.jpg",
      description:
        "We have this placed on top of our Ikea Hemnes dresser. It’s again, soft, and contoured to keep her in centered. This is a must buy.",
      category: ["Diapering"]
    },
    {
      name:
        "Stretchy Changing Pad Covers-BROLEX 2 Pack Jersey Knit Change Pad Covers For Girls Boys,Pink & White Arrow",
      price: "12.99 ",
      url:
        "https://www.amazon.com/gp/product/B071L4GTMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B071L4GTMW&linkCode=as2&tag=shopmymom-20&linkId=a93036de85345b53aaee1cce1517e621",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/61Xr0wv-agL._SX522_.jpg",
      description: "These go over for the changing pad, and is a fun pattern.",
      category: ["Diapering", "Bedding"]
    }
  ],
  3: [
    {
      name: "KidKraft Sling Bookshelf, Natural",
      price: "40.83 ",
      url:
        "https://www.amazon.com/gp/product/B0018MCVH4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0018MCVH4&linkCode=as2&tag=shopmymom-20&linkId=bd1ee1e1c0e2ee34d7426ca99ddaa2e7",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/81Ziq-7XskL._SX679_.jpg",
      description:
        "This is a nice, minimal wood colored first bookshelf. Books are prominently displayed face forward.",
      category: ["Toys"]
    }
  ],
  4: [
    {
      name:
        "babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",
      price: "299.00 ",
      url:
        "https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",
      description:
        "Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",
      category: ["Furniture"]
    },
    {
      name: "Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",
      price: "26.20 ",
      url:
        "https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",
      description:
        "From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",
      category: ["Nursery Décor"]
    },
    {
      name:
        "Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",
      price: "24.99 ",
      url:
        "https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",
      description:
        "As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",
      category: ["Bedding", "Apparel"]
    },
    {
      name:
        "Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",
      price: "17.99 ",
      url:
        "https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",
      description: "Nice design, and comfortable.",
      category: ["Bedding"]
    }
  ],
  5: [
    {
      name:
        "Skip Hop Explore and More Baby's View 3-Stage Activity Center, Multi, 4 Months",
      price: "110.19 ",
      url:
        "https://www.amazon.com/gp/product/B01J94K9OY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J94K9OY&linkCode=as2&tag=shopmymom-20&linkId=dea60cf8ed5c23737d712eb4aba48324",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/81uginCh%2BQL._SX522_.jpg",
      description:
        "This was in our registry, and we actually just put it together the other day. She can spin around, and every turn there’s something colorful and new to play with!",
      category: ["Toys"]
    }
  ],
  6: [
    {
      name: "Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",
      price: "26.20 ",
      url:
        "https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",
      imageUrl:
        "https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",
      description:
        "From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",
      category: ["Nursery Décor"]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/banner-products.js